'use strict';
import {stateGo} from 'redux-ui-router';
import 'rxjs/add/observable/combineLatest';
import {Observable} from 'rxjs/Observable';
import {getOrganization, getProject} from '../../app/model/reducers/state';
import {getId} from '../../core-utilities/domain/ReduxUtils';


ProjectsManageAssetsController.$inject = [
  '$scope',
  '$miscUtils',
  '$ngRedux',
  '$ionicViewSwitcher',
  '$toast',
  '$permissions',
  '$exceptionHandler',
  'OrganizationDomain',
  'ProjectDomain',
  'ProjectsManageAssetsFilterMixin',
  'FirebaseConnectionService',
];

const VIEW_ACTIONS = {
  canAddAsset: 'organization_assets_edit',
};

export function ProjectsManageAssetsController(
  $scope,
  $miscUtils,
  $ngRedux,
  $ionicViewSwitcher,
  $toast,
  $permissions,
  $exceptionHandler,
  OrganizationDomain,
  ProjectDomain,
  ProjectsManageAssetsFilterMixin,
  FirebaseConnectionService,
) {
  const vm = $scope.manageAssets = {};
  const filterService = ProjectsManageAssetsFilterMixin(vm, $scope);
  const selectAssetObservable = $scope.$createObservableFunction('toggleSelect');

  // TODO: verify user permission upon attempt to access view and kick if lacking permission

  vm.selectedAssets = {};
  vm.selectedAssetsToAdd = {};
  vm.selectedAssetsToRemove = {};
  vm.assetsInProgress = {};
  vm.assetsWithErrors = {};
  vm.expectedMembers = {};
  vm.newAsset = false;
  vm.assetEditor = {};

  vm.goBack = goBack;
  vm.save = $miscUtils.blockPromise(save);

  // vm.addToAssets = addToAssets;

  $scope.$evalAsync(initList);
  $permissions.bindOrg($scope, vm, VIEW_ACTIONS);
  $miscUtils.bindToExit($scope, isDirty);

  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/

  function goBack() {
    $ionicViewSwitcher.nextDirection('back');
    $ngRedux.dispatch(stateGo('app.projects.asset-projects-list'));
  }


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function addToAssets(asset) {
    if (!asset) return;
    const assetId = getId(asset);
    if (vm.selectedAssets[assetId]) {
      delete vm.selectedAssets[assetId];

      if (vm.assetProjectFilter[assetId])
        delete vm.selectedAssetsToRemove[assetId];
      else
        delete vm.selectedAssetsToAdd[assetId];
    } else {
      vm.selectedAssets[assetId] = true;

      if (vm.assetProjectFilter[assetId])
        vm.selectedAssetsToRemove[assetId] = true;
      else
        vm.selectedAssetsToAdd[assetId] = true;
    }
  }

  function save() {
    if (vm.newAsset) {
      return vm.assetEditor.save().then(withNewAsset);
    } else {
      return updateAssetsInProject();
    }
  }

  function updateAssetsInProject() {
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    if (!project) {
      $toast.showMessage('Error! Unable to load your project!', null, 'error');// TODO(i18n): convert to message code
      return Promise.reject(null);
    }

    if (!FirebaseConnectionService.online)
      return Promise.reject({code: 'default.error.offline.message'});

    const editResults = buildInProgress();
    if (editResults.totalChange === 0)
      return $toast.showMessage('You must select an asset first!', null, 'error');// TODO(i18n): convert to message code

    const promises = [];
    const adding = editResults.adding;
    const removing = editResults.removing;

    for (const assetId in editResults.inProgress) {
      if (editResults.inProgress.hasOwnProperty(assetId))
        vm.assetsInProgress[assetId] = true;
    }

    // TODO: create add/remove assets(plural) methods
    if (adding.length)
      promises.push(project.addAssets(adding).catch(handleSaveError(getId(project), adding, true)));
    if (removing.length)
      promises.push(project.removeAssets(removing).catch(handleSaveError(getId(project), removing, false)));

    return Promise.all(promises)
      .then(function () {
        // TODO(i18n): convert to message code and pluralize
        // TODO: consider reporting the list of assets in each category?
        if (adding.length > 0)
          $toast.showMessage(adding.length === 1 ? 'Asset Added!' : 'Assets Added!', null, 'info');
        if (removing.length > 0)
          $toast.showMessage(removing.length === 1 ? 'Asset Removed!' : 'Assets Removed!', null, 'info');
      })
      .catch(function (error) {
        console.error(error);
      });// TODO: show errors in view
  }

  /**
   * @typedef {Object} InProgressReport
   * @property {Array<String>} adding
   * @property {Array<String>} removing
   * @property {Object<String,Boolean>} inProgress
   * @property {number} totalChange
   */

  /**
   *
   * @returns {InProgressReport}
   */
  function buildInProgress() {
    const adding = [];
    const removing = [];
    const inProgress = {};
    let totalChange = 0;

    for (const dataTagId in vm.selectedAssets) {
      if (vm.selectedAssets.hasOwnProperty(dataTagId) && !vm.assetsInProgress[dataTagId]) {
        inProgress[dataTagId] = true;
        totalChange++;
        if (vm.selectedAssetsToRemove[dataTagId]) {
          removing.push(dataTagId);
        } else {
          adding.push(dataTagId);
        }
      }
    }

    return {
      adding: adding,
      removing: removing,
      inProgress: inProgress,
      totalChange: totalChange,
    };
  }

  /**
   *
   * @param {String} projectId
   * @param {Array<String>} assets
   * @param {Boolean} adding
   * @returns {Function}
   */
  function handleSaveError(projectId, assets, adding) {
    const prefix = `Failed to ${adding ? 'add' : 'remove'} asset `;
    const postfix = `${adding ? ' to' : ' from'} project ${projectId}`;
    return function (error) {
      assets.map(assetId => {
        delete vm.assetsInProgress[assetId];
        delete vm.selectedAssets[assetId];
        vm.assetsWithErrors[assetId] = true;
        $exceptionHandler(error, prefix + assetId + postfix);
      });
    };
  }

  function withNewAsset(asset) {
    vm.selectedAssets = {};
    vm.selectedAssets[getId(asset)] = asset;
    vm.assetEditor.reset();
    return updateAssetsInProject();
  }

  function isDirty() {
    if (!getProject($ngRedux.getState())) {
      return false;
    } else {
      const result = buildInProgress();
      return result.totalChange > 0;
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  vm.toggleNewAsset = toggleNewAsset;

  function toggleNewAsset() {
    vm.selectedAssets = {};
    vm.newAsset = !vm.newAsset;
  }

  function watchAssetProjects(filterObservables) {
    const toggledAsset$ = selectAssetObservable.map(function (asset) {
      addToAssets(asset);
      return asset;
    });
    const merger$ = Observable.combineLatest(
      filterObservables.getAssetProjectList$(),
      toggledAsset$.startWith(null),
      function (assetsInProject) {
        return assetsInProject;
      });

    filterService.addSubscription(merger$
      .subscribe(function (results) {
        $scope.$evalAsync(buildExpectedMembers.bind(null, results));
      })
    );
  }

  function buildExpectedMembers(assetsInProject) {
    // Update in progress states
    for (const idInProgress in vm.assetsInProgress) {
      if (vm.assetsInProgress.hasOwnProperty(idInProgress)) {
        if (vm.selectedAssetsToRemove[idInProgress] && !assetsInProject[idInProgress]) {
          delete vm.expectedMembers[idInProgress];
          delete vm.selectedAssets[idInProgress];
          delete vm.assetsInProgress[idInProgress];
          delete vm.selectedAssetsToRemove[idInProgress];

        } else if (vm.selectedAssetsToAdd[idInProgress] && assetsInProject[idInProgress]) {
          delete vm.expectedMembers[idInProgress];
          delete vm.selectedAssets[idInProgress];
          delete vm.assetsInProgress[idInProgress];
          delete vm.selectedAssetsToAdd[idInProgress];
        }
      }
    }

    // Determine new membership
    for (const assetId in assetsInProject) {
      if (assetsInProject.hasOwnProperty(assetId)) {
        if (!vm.selectedAssets[assetId]) {
          vm.expectedMembers[assetId] = true;
        } else {
          delete vm.expectedMembers[assetId];
        }
      }
    }

    for (const selectedId in vm.selectedAssets) {
      if (vm.selectedAssets.hasOwnProperty(selectedId) && !assetsInProject[selectedId]) {
        vm.expectedMembers[selectedId] = true;
      }
    }

    for (const expectedId in vm.expectedMembers) {
      if (vm.expectedMembers.hasOwnProperty(expectedId)
        && !vm.selectedAssets.hasOwnProperty(expectedId)
        && !assetsInProject.hasOwnProperty(expectedId)) {

        delete vm.expectedMembers[expectedId];
      }
    }

    // console.log('current members')
    // console.log(assetsInProject)
    //
    // console.log('expected members')
    // console.log(vm.expectedMembers)
    //
    // console.log('selectedAssets')
    // console.log(vm.selectedAssets)
    //
    // console.log('removing')
    // console.log(vm.selectedAssetsToRemove)
    //
    // console.log('adding')
    // console.log(vm.selectedAssetsToAdd)
  }


  /*****************************************************************************************************************
   * Initialization
   ****************************************************************************************************************/

  function initList() {
    // TODO(redux-domain): Convert and also re-implement to remove nested stream subscriptions if feasible
    const organization$ = $ngRedux.state$
      .map(getOrganization)
      .distinctUntilChanged(null, organization => getId(organization))
      .filter(organization => !!organization);

    const project$ = $ngRedux.state$
      .map(getProject)
      .distinctUntilChanged(null, project => getId(project))
      .filter(project => !!project);

    Observable
      .combineLatest(
        organization$,
        project$,
        (organization, project) => ({organization, project})
      )
      .take(1)
      .subscribe(state => {
        $scope.$evalAsync(() => {
          const assetList = OrganizationDomain.$getAssetsList(getId(state.organization));
          const assetProjectList = ProjectDomain.$getAssetProjectsList(getId(state.project));

          const observables = filterService.initFiltering(assetList, assetProjectList);
          watchAssetProjects(observables);
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/controllers/ProjectsManageAssetsController.js